<template>
  <nav :class="['flexRow', loggedIn ? '' : 'guest']">
    <div>
      <router-link to="/" exact>Block32</router-link>
      <router-link to="/day">Day</router-link>
      <router-link to="/week" v-if="!isMobile()">Week</router-link>
      <router-link to="/month" v-if="!isMobile()">Month</router-link>
      <router-link to="/realtime" v-if="isBetaUser">Realtime</router-link>
      <router-link to="/line" v-if="isBetaUser">Line</router-link>
      <router-link to="/trend" v-if="!isMobile() && isBetaUser"
        >Trend</router-link
      >
      <router-link to="/changes" v-if="!isMobile() && isBetaUser"
        >Changelog</router-link
      >

      <!-- <router-link to="/category">Categories</router-link> -->
    </div>
    <div class="flexRow">
      <div class="helpLink">
        <router-link to="/help" v-if="!isMobile() && isBetaUser"
          >Help</router-link
        >
      </div>
      <user-profile-link />
    </div>
  </nav>
</template>

<script>
import UserProfileLink from "./UserProfileLink.vue";

import util from "../util.js";
import auth from "../auth.js";
import eventHub from "../eventHub.js";

export default {
  name: "app-header",
  mixins: [util.getMobileMixin()],
  components: {
    "user-profile-link": UserProfileLink,
  },
  props: {
    isBetaUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loggedIn: auth.loggedIn(),
    };
  },
  created() {
    eventHub.$on("user-logged-in", () => {
      this.loggedIn = true;
    });
    eventHub.$on("user-logged-out", () => {
      this.loggedIn = false;
    });
  },
};
</script>

<style>
nav {
  box-sizing: border-box;
  padding: 0 0.5rem;
  height: 2rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  transition: all 0.5s;
  /*border-bottom: 1px solid #ddd;*/
}

nav.guest {
  opacity: 0;
}

nav.flexRow {
  justify-content: space-between;
}

/* FIXME - BETTER STYLING HERE PLEASE */
nav a {
  color: #2c3e50;
  text-decoration: none;
  padding: 0.125rem 0.5rem;
  height: 2rem;
}

nav .router-link-active {
  color: white;
  background-color: #3498db;
}

nav .helpLink {
  margin-right: 0.5rem;
  padding-right: 0.25rem;
  border-right: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// AppHeader.vue?f7001cda